<template>
  <page>
    <template slot="content">
    <help-content :title="'歩数は激増しているまたは歩いても計測されない(Android)'">
      <template slot="content">
        <div class="text">
          スマホのハードウェアに異常が生じている可能性があります。スマホを再起動することで問題が解決されることがあります。繰り返し現象が発生する場合、ハードウエアが故障している可能性が高く、歩数計測にWeBandのご利用はおすすめです。
        </div>
      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help8.vue